import { Config } from '@comall-backend-builder/core/lib/parser';
import { OrderPrint } from '../containers';

export let config: Config = {
    entities: {},
    components: {
        OrderPrintView: {
            component: 'Card',
            title: '订单打印',
            content: {
                component: 'OrderPrint',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    breadcrumbName: '交易管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/orderPrint',
                            component: 'Viewport',
                            breadcrumbName: '订单打印',
                            childRoutes: [
                                {
                                    path: '/',
                                    component: 'OrderPrintView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
